import { Box, Grid, Tab } from "@material-ui/core";
import { TabContext, TabList } from "@material-ui/lab";
import useCustomState from "../../hooks/State";
import {
  BarChart,
  Contactless,
  History,
  Info,
  LiveTv,
  Settings,
} from "@material-ui/icons";
import "./liveDevices.css";
import NoData from "../BillsFilter/NotFound";
import LiveShow from "./LiveShow";
import DeviceHistory from "./DeviceHistory";
import DeviceInfo from "./DeviceInfo";
import DeviceCharts from "./DeviceCharts";
import DeviceOrders from "./DeviceOrders";
import DeviceSettings from "./DeviceSettings";
import Swal from "sweetalert2";

const LiveDevice = ({
  information,
  records,
  changeTablePage,
  tablePage,
  orderTypes,
  deviceOrders,
  orderPage,
  updateOrder,
  changeOrderPage,
  lastData,
  lastID,
}) => {
  const iconStyle = { marginLeft: "7px", fontFamily: "Vazir" };
  const TabValue = useCustomState("0");
  const changeTab = (e, newValue) => {
    TabValue.handleChange(newValue);
  };
  const renderTabContext = (tabValue) => {
    switch (tabValue) {
      case "0":
        return (
          <LiveShow
            deviceInfo={information.value}
            changeTab={changeTab}
            data={lastData}
          />
        );
      case "1":
        return (
          <DeviceHistory
            records={records}
            changePage={changeTablePage}
            page={tablePage}
          />
        );
      case "2":
        return <DeviceInfo deviceInfo={information.value} />;
      // case "3":
      //   return <DeviceCharts deviceInfo={information} />;
      case "4":
        return (
          <DeviceOrders
            orderTypes={orderTypes}
            orders={deviceOrders}
            orderPage={orderPage}
            updateTable={updateOrder}
            deviceInfo={information.value}
            changePage={changeOrderPage}
          />
        );
      case "5":
        return <DeviceSettings deviceInfo={information} />;
      default:
        return <NoData message={"در بارگزاری این منو مشکلی پیش آمده"} />;
    }
  };
  const doUpdates = () => {
    Swal.fire({
      toast: true,
      showCancelButton: false,
      showConfirmButton: false,
      title: "به روز رسانی انجام شد",
      timer: 4000,
      icon: "info",
      position: "top-start",
      timerProgressBar: true,
    });
    changeTablePage(tablePage);
    changeOrderPage(orderPage);
  };
  const checkUpdates = () => {
    if (lastID.value && lastData && lastID.value !== lastData.consumption_id) {
      lastID.handleChange(lastData.consumption_id);
      doUpdates();
    }
  };
  (() => {
    checkUpdates();
  })();
  return (
    <Grid
      container
      style={{ padding: "5px 16px" }}
      className="live-device-tabs"
    >
      <Box
        sx={{
          width: "100%",
          typography: "body1",
          background: "white",
        }}
        style={{
          boxShadow: "0 1px 1px 0 #999",
          borderRadius: "5px",
        }}
      >
        <TabContext value={TabValue.value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <TabList
                onChange={changeTab}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                indicatorColor="secondary"
              >
                <Tab
                  icon={<LiveTv style={iconStyle} />}
                  iconPosition="start"
                  label="نمایش زنده"
                  value="0"
                />
                <Tab
                  icon={<History style={iconStyle} />}
                  iconPosition="start"
                  label="سوابق"
                  value="1"
                />
                <Tab
                  icon={<Info style={iconStyle} />}
                  iconPosition="start"
                  label="مشخصات"
                  value="2"
                />
                {/* <Tab
                  icon={<BarChart style={iconStyle} />}
                  iconPosition="start"
                  label="نمودارها"
                  value="3"
                /> */}
                <Tab
                  icon={<Contactless style={iconStyle} />}
                  iconPosition="start"
                  label="دستورات"
                  value="4"
                />
                <Tab
                  icon={<Settings style={iconStyle} />}
                  iconPosition="start"
                  label="تنظیمات"
                  value="5"
                />
              </TabList>
            </Grid>
          </Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Grid
              container
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                borderRadius: " 0 0 8px 8px",
                boxShadow: "0px 2px 2px 0px #444",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              {renderTabContext(TabValue.value)}
            </Grid>
          </Box>
        </TabContext>
      </Box>
    </Grid>
  );
};
export default LiveDevice;
